<div class="card-dropdown  {{width ? 'w-100' : ''}}" [class.is-disabled]="disabled">

  <!-- ===== Label ===== -->
  <label class="dropdown-label" *ngIf="label">
    {{ label }}
    <span class="required-star" *ngIf="required">*</span>
  </label>

  <button #trigger class="dropdown-trigger" type="button" [disabled]="disabled" [attr.aria-expanded]="isOpen"
    aria-haspopup="listbox" (click)="toggle()">
    <span class="trigger-content">
      @if (multiSelect) {
      <!-- Multi-select display -->
      @if (selectedItems.length > 0) {
      @if (selectedTemplate) {
      <ng-container [ngTemplateOutlet]="selectedTemplate" [ngTemplateOutletContext]="{ $implicit: selectedItems }">
      </ng-container>
      } @else {
      <span class="multi-select-badge">{{ selectedItems.length }} selected</span>
      }
      } @else {
      @if (!placeholder) {
      <span>Select Item</span>
      } @else {
      <span>{{placeholder}}</span>
      }
      }
      } @else {
      <!-- Single select display -->
      @if ( selectedItem?.[optionKey] || selectedItem) {
      @if (selectedTemplate) {
      <ng-container [ngTemplateOutlet]="selectedTemplate" [ngTemplateOutletContext]="{ $implicit: selectedItem }">
      </ng-container>
      } @else {
      {{ getLabel(selectedItem) }}
      }
      } @else {
      @if (!placeholder) {
      <span>Select Item</span>
      } @else {
      <span>{{placeholder}}</span>
      }
      }
      }
    </span>

    <span class="trigger-actions">
      <!-- Clear button -->
      @if (clearable && hasValue && !disabled) {
      <button type="button" class="clear-btn" (click)="clearSelection($event)" title="Clear selection">
        <i class="pi pi-times"></i>
      </button>
      }

      <!-- Arrow -->
      <span class="arrow" [class.is-open]="isOpen">
        <i class="pi pi-chevron-down"></i>
      </span>
    </span>
  </button>

  <div class="dropdown-panel" role="listbox" [class.is-open]="isOpen" (click)="onPanelClick($event)">

    @if (filter) {
    <div class="dropdown-filter-input">
      <input type="text" placeholder="Filter" [(ngModel)]="filterText" (click)="$event.stopPropagation()">
    </div>
    }

    @for (item of data! | dropdownFilter : filterKey : filterText; track $index; let i = $index) {
    @if (itemTemplate) {
    <ng-container [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: item, select: selectItem.bind(this), isSelected: isItemSelected(item) }">
    </ng-container>
    } @else {
    <span (click)="selectItem(item)" class="dropdown-item" [class.selected]="isItemSelected(item)" [style.--i]="i">
      @if (multiSelect) {
      <span class="checkbox-wrapper">
        <i class="pi" [class.pi-check-square]="isItemSelected(item)" [class.pi-square]="!isItemSelected(item)"></i>
      </span>
      }
      {{ getLabel(item) }}
    </span>
    }
    }

  </div>
</div>